export const GQL_PROJECT_DEFAULT_FIELDS = `
  id
  title
  description
  key
  chatsAmount
  chatsActiveAmount
  createdBy {
    id
    username
    firstname
    lastname
    date
  }
  updatedBy {
    id
    username
    firstname
    lastname
    date
  }
  archivedBy {
    id
    username
    firstname
    lastname
    date
  }
  pausedBy {
    id
    username
    firstname
    lastname
    date
  }`

export const GQL_PROJECT_ASSISTANT_FILE_DEFAULT_FIELDS = `
  projectId
  key
  name
  mimeType
  sizeBytes
  options {
    chatGptIsIncluded
  }
  createdBy {
    id
    username
    lastname
    firstname
    date
  }
  updatedBy {
    id
    username
    lastname
    firstname
    date
  }
`
export const GQL_PROJECT_CHATGPT_RESPONSES_API_DEFAULT_FIELDS = `
  model
  instructions
`

export const GQL_PROJECT_ASSISTANT_DEFAULT_FIELDS = `
  isDefault
  fileKey
  fileName
  filePath
`
